var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"variant":_vm.status.variant}},[_vm._v(_vm._s(_vm.status.text))])}
var staticRenderFns = []

export { render, staticRenderFns }